import _ from "lodash";
import * as Team from "src/state/modules/team";

export type SortableTeamMember = Team.Player;

export const teamMemberOrPlayerComparator = (a: SortableTeamMember, b: SortableTeamMember) => {
  const jerseyA = jerseyNumber(a);
  const jerseyB = jerseyNumber(b);

  if (_.isString(jerseyA) && _.isNumber(jerseyB)) return 1;
  if (_.isString(jerseyB) && _.isNumber(jerseyA)) return -1;

  if (_.lt(jerseyA, jerseyB)) {
    return -1;
  }
  if (_.gt(jerseyA, jerseyB)) {
    return 1;
  }

  const oneOfA = oneOfFirstLastEmail(a);
  const oneOfB = oneOfFirstLastEmail(b);

  return oneOfA.localeCompare(oneOfB);
};

export const jerseyNumber = (p: SortableTeamMember) => {
  const jersey = _.get(p, ["playerAttributes", "jerseyNumber"]) || _.get(p, "number") || "";
  if (_.isNil(jersey) || _.isEmpty(jersey)) return "";

  const jerseyNoNumbers = _.trim(jersey, "0123456789");
  if (!_.isEmpty(jerseyNoNumbers)) return jersey;

  return parseInt(jersey, 10);
};
export const oneOfFirstLastEmail = (p: SortableTeamMember) =>
  _.find([p.first_name, p.last_name, _.get(p, "email")], _.negate(_.isEmpty)) || "";
